import Reveal from "../components/Reveal";
import QuoteForm from "../components/QuoteForm";
import PortfolioGallery from "../components/PortfolioGallery";
import SEO from "../components/SEO";
import { serviceJsonLd } from "../data/seo";
import { CheckCircle2 } from "lucide-react";

const FEATURES = [
  "Dedicated head of photography (Keith Lupton)",
  "Pre-shoot research & shot-list planning",
  "Studio or on-location across the UK",
  "Digital images delivered within days",
  "Full copyright & unlimited usage included",
];

export default function Photography() {
  return (
    <main className="pt-28 pb-12" data-testid="photography-page">
      <SEO
        title="Photographer Liverpool | Commercial Photography | Yellow"
        description="Liverpool photographer for products, portraits, events, fashion & property. Studio or on-location, covering the entire UK. See the portfolio and get a fixed quote in 4 hours."
        path="/photography-liverpool"
        keywords="photographer liverpool, photography liverpool, commercial photographer liverpool, commercial photography liverpool, product photography liverpool, corporate photography liverpool, brand photography liverpool, studio photography liverpool"
        jsonLd={serviceJsonLd({
          name: "Photography Liverpool",
          description:
            "Commercial photography in Liverpool, products, services, people and facilities. Studio or on-location across the UK.",
          path: "/photography-liverpool",
        })}
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Photography", path: "/photography-liverpool" },
        ]}
      />
      <section className="yv-container">
        <Reveal>
          <p className="yv-eyebrow">Photographer Liverpool</p>
          <h1 className="yv-h1 mt-3 max-w-5xl">
            <span style={{ color: "var(--yellow)" }}>Commercial photography in Liverpool</span> of your services, products, people and facilities.
          </h1>
          <p className="text-white/70 max-w-3xl mt-6 text-lg leading-relaxed">
            Want a <strong className="text-white">photographer in Liverpool</strong> who genuinely reflects your brand? Our head of photography
            <strong className="text-white"> Keith Lupton </strong>
            and his team build a library of images you can use across your marketing, covering the entire UK from location to studio.
          </p>
        </Reveal>
      </section>

      <section className="yv-container !mt-24 !mb-24 grid md:grid-cols-2 gap-10 items-start">
        <Reveal>
          <div className="relative rounded-md overflow-hidden border border-white/10">
            <img
              src="/wp-cache/keith-camera-scaled.jpg"
              alt="Yellow Photography"
              className="w-full"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        </Reveal>
        <Reveal delay={150}>
          <h2 className="yv-h2 text-white mb-4">A library of imagery that's yours to keep.</h2>
          <p className="text-white/70 leading-relaxed mb-6">
            Keith and his team work closely with you to research the style of images you need. Shoots are planned and scheduled so you know exactly what's required beforehand. Digital images are delivered a few days after the shoot, and you get full copyright with unlimited use.
          </p>
          <ul className="space-y-3">
            {FEATURES.map((f) => (
              <li key={f} className="flex gap-3 text-white/80">
                <CheckCircle2 className="text-[var(--yellow)] flex-shrink-0 mt-0.5" size={20} />
                <span>{f}</span>
              </li>
            ))}
          </ul>
        </Reveal>
      </section>

      <PortfolioGallery />

      <section className="yv-container mt-20 max-w-2xl mx-auto">
        <Reveal>
          <QuoteForm heading="Tell us your photography requirements" />
        </Reveal>
      </section>
    </main>
  );
}
